import Character from "@lss/common/src/shell/Character";
import { TimageINT } from "../../src/store/slices/gameObjectSlice";
import { parseRequire } from "../../src/utils/parseImageUrl";
import { annImages, annOtherPics, annProfilesPic } from "../helpers/annInstaImages";

type TOD1Names = "vanessa" | "mc" | "joe";
export interface AnnPropertiesINT {
    // Insta
    instaImages: number[],
    hasInsta: boolean,
    instaNickName: string,
    instaDescription: string,
    instaProfileImage: TimageINT & { key?: string; },
    instaFollowing: number,
    instaFollowers: number,
    v7PhotoShootPhotosMCPicked: string[],
    v7PhotoShootPhotosMCDenied: string[],
    v7PhotoShootPhotosANNPicked: string[],





    corruption: number,
    likedDuringTOD?: TOD1Names | "chris";
    kissedDuringTOD: TOD1Names[],
    v4JoeyBirthdayDrinksNum: number,
    v4DrankDrug: boolean,
    isCorrupted: boolean,
    v7ActressJob?: boolean,
    v1AnnWallpaper: TimageINT,

    tookDrugPill: boolean,
}

const annProperties: AnnPropertiesINT = {
    // INSTA
    instaImages: [],
    instaNickName: "sweet_ann",
    instaDescription: `I love to study and read for fun :)`,
    instaProfileImage: annProfilesPic.annInstaPortrait1,
    hasInsta: false,
    v1AnnWallpaper: annOtherPics.wallpaper1,
    instaFollowers: 1,
    instaFollowing: 56,
    corruption: 0,
    kissedDuringTOD: [],
    v4JoeyBirthdayDrinksNum: 0,
    v4DrankDrug: false,
    isCorrupted: false,
    v7PhotoShootPhotosMCDenied: [],
    v7PhotoShootPhotosMCPicked: [],
    v7PhotoShootPhotosANNPicked: [],
    tookDrugPill: false,



};

const ann = new Character<AnnPropertiesINT>("Ann", annProperties, "#FF63C7FF", undefined);

export {
    ann,
};
